import logUtil from 'utils/log'
import getSelectedMediaIndexFromSelectedVariantGiftSelect from 'modules/gift/redux/selectors/get-media-index-from-selected-variant'
import updateSelectedIndexMediaGalleryAction from 'modules/media-gallery/redux/actions/update-selected-index'

export default function updateSelectedMediaFromVariantQuickShopAction () {
  return (dispatch, getState) => {
    const selectedMediaIndex = getSelectedMediaIndexFromSelectedVariantGiftSelect(getState())
    const logPrefix = `selectedMediaIndex=${selectedMediaIndex}`
    logUtil('updateSelectedMediaFromVariantQuickShopAction').debug(`${logPrefix} [start]`)

    if (selectedMediaIndex === -1) {
      logUtil('updateSelectedMediaFromVariantQuickShopAction').debug(`${logPrefix} [noop]`)
      return
    }

    dispatch(updateSelectedIndexMediaGalleryAction(selectedMediaIndex))
    logUtil('updateSelectedMediaFromVariantQuickShopAction').debug(`${logPrefix} [done]`)
  }
}
